<template>
  <b-col sm="12" md="12" lg="12" xl="12">
    <b-form-group
      label="Instrumentador responsável"
      label-for="instrumentador_responsavel"
      label-class="float-left"
    >
      <b-form-input
        name="instrumentador_responsavel"
        v-model="instrumentador"
        @input="(v) => $emit('updateModel', { instrumentador: v })"
        class="invision-input input-icon"
        :disabled="isBusy"
        v-validate="{ required: true }"
        :state="validateState('instrumentador_responsavel')"
      ></b-form-input>
    </b-form-group>
  </b-col>
</template>

<script>
export default {
  name: 'InstrumentadorResponsavel',
  inject: ['validator', 'validateState'],
  created() {
    this.$validator = this.validator;
  },
  data() {
    return {
      instrumentador: '',
    };
  },
  props: {
    isBusy: {
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
    },
  },
};
</script>
